import { combineReducers } from "redux";
import { getValueAtPath, withProperties } from "../../utils";
import withConstantStateFactory from "../helpers/reducers/constant";
import { SET_SESSION_EXPIRY, SET_SESSION_EXPIRED } from "../helpers/actions";

export default function state() {
    const NAME = 'session';
    const $state = Object.create(null);
    const { data } = this;
    const session_duration = getValueAtPath(data, 'session_duration') || null;
    let custom_duration = null;
    // reduce from 1440 (24hours) => 15mins
    if (typeof session_duration === 'number' && session_duration > 0 && session_duration <= 15) {
        custom_duration = session_duration;
    }
    const ConstantState = withConstantStateFactory({
        session_duration: custom_duration,
    });

    function expiresAtReducer(state = null, action) {
        switch (action.type) {
        case SET_SESSION_EXPIRY:
            return typeof action.payload === 'number' ? action.payload : state;
        default:
            return state;
        }
    }

    function expiredReducer(state = false, action) {
        switch (action.type) {
        case SET_SESSION_EXPIRED:
            return true;
        default:
            return state;
        }
    }

    function interactingReducer(state = false, action) {
        switch (action.type) {
        case 'SET_INTERACTING':
            return true;
        default:
            return state;
        }
    }

    const Reducer = combineReducers({
        ...ConstantState,
        expiresAt: expiresAtReducer,
        expired: expiredReducer,
    });

    function setExpiry(ts) {
        return { type: SET_SESSION_EXPIRY, payload: ts };
    }
    function setExpired() {
        return { type: SET_SESSION_EXPIRED };
    }

    withProperties($state, {
        NAME,
        Reducer,
        actions: withProperties(Object.create(null), { setExpiry, setExpired }),
    });
    return (state = $state);
}